// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__3K3uC","empty":"ModalGraph_empty__b3md0"};